export default __webpack_public_path__ + "img/5a4e596e52de745d1eb78625a87442ff.svg";